import { SearchMode } from "helpers/api";
import lottieDeepSearch from "../features/Thread/components/ThreadInteractionStepInfoBar/assets/lottie_deep_search.json";
import lottieProSearch from "../features/Thread/components/ThreadInteractionStepInfoBar/assets/lottie_pro_search.json";
import lottieQuickSearch from "../features/Thread/components/ThreadInteractionStepInfoBar/assets/lottie_quick_search.json";
import {
  DEEP_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER,
  DEEP_SEARCH_CREDITS_PER_MONTH_FREE_USER,
  DEEP_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER,
  DEEP_SEARCH_CREDITS_PER_MONTH_DEEP_USER,
  DEEP_SEARCH_CREDITS_PER_MONTH_TEAM_USER,
  DEEP_SEARCH_CREDITS_PER_MONTH_ENTERPRISE_USER,
  PRO_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER,
  PRO_SEARCH_CREDITS_PER_MONTH_FREE_USER,
  PRO_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER,
  PRO_SEARCH_CREDITS_PER_MONTH_DEEP_USER,
  QUICK_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER,
  QUICK_SEARCH_CREDITS_PER_MONTH_FREE_USER,
  QUICK_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER,
  QUICK_SEARCH_CREDITS_PER_MONTH_DEEP_USER,
} from "./config";
import type { SubscriptionTier } from "helpers/subscription";

export const SEARCH_MODE_ANIMATIONS = {
  [SearchMode.PRO_RESEARCH]: lottieDeepSearch,
  [SearchMode.PRO_ANALYSIS]: lottieProSearch,
  [SearchMode.SUMMARY]: lottieQuickSearch,
};

export const SEARCH_MODE_ICONS = {
  [SearchMode.PRO_RESEARCH]: "/icons/icon_deep_search.svg",
  [SearchMode.PRO_ANALYSIS]: "/icons/icon_pro_search.svg",
  [SearchMode.SUMMARY]: "/icons/icon_quick_search.svg",
};

export const SEARCH_MODE_LABEL_KEYS = {
  [SearchMode.SUMMARY]: "quick",
  [SearchMode.PRO_ANALYSIS]: "pro",
  [SearchMode.PRO_RESEARCH]: "deep",
} as const;

export const getSearchModeLabelKey = (mode: SearchMode): string => {
  return SEARCH_MODE_LABEL_KEYS[mode] || "unknown";
};

export const getMaxCreditsPerMonth = (
  mode: SearchMode,
  isNotSignedIn: boolean,
  subscriptionTier: SubscriptionTier
): number | null => {
  switch (mode) {
    case SearchMode.PRO_RESEARCH:
      if (isNotSignedIn) return DEEP_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER;
      switch (subscriptionTier) {
        case "deep":
          return DEEP_SEARCH_CREDITS_PER_MONTH_DEEP_USER; // 200
        case "premium":
          return DEEP_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER; // 15
        case "team":
          return DEEP_SEARCH_CREDITS_PER_MONTH_TEAM_USER; // 50
        case "enterprise":
          return DEEP_SEARCH_CREDITS_PER_MONTH_ENTERPRISE_USER; // 50
        default:
          return DEEP_SEARCH_CREDITS_PER_MONTH_FREE_USER;
      }
    case SearchMode.PRO_ANALYSIS:
      if (isNotSignedIn) return PRO_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER;
      switch (subscriptionTier) {
        case "deep":
          return PRO_SEARCH_CREDITS_PER_MONTH_DEEP_USER; // Unlimited
        case "premium":
        case "team":
        case "enterprise":
          return PRO_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER; // Unlimited
        default:
          return PRO_SEARCH_CREDITS_PER_MONTH_FREE_USER;
      }
    case SearchMode.SUMMARY:
      if (isNotSignedIn) return QUICK_SEARCH_CREDITS_PER_MONTH_ANONYMOUS_USER;
      switch (subscriptionTier) {
        case "deep":
          return QUICK_SEARCH_CREDITS_PER_MONTH_DEEP_USER; // Unlimited
        case "premium":
        case "team":
        case "enterprise":
          return QUICK_SEARCH_CREDITS_PER_MONTH_PREMIUM_USER; // Unlimited
        default:
          return QUICK_SEARCH_CREDITS_PER_MONTH_FREE_USER;
      }
    default:
      return 0;
  }
};
